import { render, staticRenderFns } from "./AddViolationDialog.vue?vue&type=template&id=05da270a"
import script from "./AddViolationDialog.vue?vue&type=script&lang=js"
export * from "./AddViolationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports